export const getSelectCustomStyles = (error?: string) => ({
  container: (provided: CSSStyleDeclaration) => ({ ...provided, fontFamily: 'var(--font_family-accent)' }),
  control: (provided: CSSStyleDeclaration, { isFocused }: any) => ({
    ...provided,
    height: '44px',
    borderRadius: '5px',
    border: `1px solid ${error ? '#D72C0D' : '#E0E0E0'}`,
    fontSize: '16px',
    color: '#212121',
    transition: '200ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    boxShadow: isFocused ? 0 : 0,
    '&:hover': {
      boxShadow: isFocused ? 0 : 0,
      borderColor: '#b3b3b3',
    },
  }),
  option: (provided: CSSStyleDeclaration, { isFocused }: any) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    cursor: 'pointer',
    fontSize: '14px',
    padding: '10px 8px',
    borderBottom: '1px solid #EEE',
    overflow: 'hidden',
    transition: '0.3s',
    color: isFocused && '#3E3E40',
    backgroundColor: isFocused ? '#f5f5f5' : 'transparent',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  }),
  valueContainer: (provided: CSSStyleDeclaration) => ({ ...provided, padding: '0 8px' }),
  indicatorSeparator: (provided: CSSStyleDeclaration) => ({ ...provided, margin: 0, backgroundColor: '#E0E0E0' }),
  clearIndicator: (provided: CSSStyleDeclaration) => ({ ...provided, cursor: 'pointer' }),
  singleValue: (provided: CSSStyleDeclaration) => ({ ...provided, paddingTop: '12px' }),
  input: (provided: CSSStyleDeclaration) => ({ ...provided, paddingTop: '17px', margin: '0 2px' }),
  menu: (provided: CSSStyleDeclaration) => ({ ...provided, zIndex: 3, overflow: 'hidden' }),
  menuList: (provided: CSSStyleDeclaration) => ({ ...provided, padding: 0 }),
  loadingMessage: (provided: CSSStyleDeclaration) => ({ ...provided, fontSize: '20px' }),
  dropdownIndicator: (provided: CSSStyleDeclaration) => ({ ...provided, padding: 0 }),
});
